export const checkout = {
  labels: {
    title: "Checkout",
    customer: "Dados do Pagador",
    continue: "Continuar",
    card: "Cartão",
    pay: "Pagar",
    processing: "Processando",
  },
  success: {
    title: "Pagamento realizado com sucesso!",
    pending_title: "Pagamento em processamento",
    canceled_title: "Pagamento cancelado",
    refunded_title: "Pagamento reembolsado",
    processing_title: "Processando pagamento",

    message: "Sua assinatura foi ativada com sucesso. Bem-vindo(a)!",
    pending_message:
      "Seu pagamento está sendo processado. Você será notificado quando for confirmado.",
    canceled_message:
      "O pagamento foi cancelado. Nenhuma cobrança foi realizada.",
    refunded_message:
      "O pagamento foi reembolsado. Sua assinatura foi cancelada.",
    processing_message:
      "Estamos processando seu pagamento. Por favor, aguarde.",

    subscription_id: "ID da Assinatura",
    stripe_id: "ID do Stripe",
    status: "Status",
    amount: "Valor",
    paid_at: "Pago em",

    status_success: "Ativa",
    status_pending: "Pendente",
    status_canceled: "Cancelada",
    status_refunded: "Reembolsada",
    status_processing: "Processando",

    go_to_dashboard: "Ir para o Dashboard",
    go_to_plans: "Ver Planos",
    contact_support: "Contatar Suporte",
    back_to_plans: "Voltar para os Planos",

    next_steps_title: "Próximos Passos",
    step1_title: "Confirme seu email",
    step1_description:
      "Você receberá um email com os detalhes da sua assinatura e instruções de acesso.",
    step2_title: "Complete seu perfil",
    step2_description:
      "Acesse o dashboard e complete suas informações para aproveitar todos os recursos.",
    step3_title: "Explore os recursos",
    step3_description:
      "Comece a usar todas as funcionalidades disponíveis no seu plano.",
  },
};
